import { useState } from "react";
import { toast } from "sonner";
import { api, errText } from "../lib/api";
import { IsoAlertFields } from "./IsoAlertFields";

export const IsoAlertOwnerCard = ({ listing, fr }) => {
  const [v, setV] = useState({ iso_alert: listing.iso_alert !== false, iso_range: listing.iso_range || "100" });
  const [busy, setBusy] = useState(false);
  const save = async (next) => {
    const prev = v;
    setV(next); setBusy(true);
    try {
      await api.patch(`/my/listings/${listing.id}/iso-alert`, next);
      toast.success(next.iso_alert ? (fr ? "Alertes mises à jour" : "Match alerts updated") : (fr ? "Alertes désactivées" : "Match alerts off"));
    } catch (e) { setV(prev); toast.error(errText(e)); }
    finally { setBusy(false); }
  };
  return <div data-testid="iso-owner-alerts"><IsoAlertFields on={v.iso_alert} range={v.iso_range} onChange={save} fr={fr} disabled={busy} /></div>;
};
